// extracted by mini-css-extract-plugin
export default {"sec2-comp-col2":"Sec2Comp_sec2-comp-col2__fSvKS"};